export default __webpack_public_path__ + "static/media/DisneyPrincessBelle1.5076e645.jpg";